import { Tag } from "./tag";
import { User } from "./user";

export class UserTagsResponse {
    userTagId: number;
    assignmentName: string;
    status: string;
    user : User;
    tags : Tag[];
    assignedDate: string;
    completionDate: string | null;
    targetCompletionDate: string;
    daysLeft: number;
    overdue: boolean;

    constructor() {
        this.userTagId = 0;
        this.assignmentName = "";
        this.status = "";
        this.user = new User();
        this.tags = [];
        this.assignedDate = "";
        this.completionDate = null;
        this.targetCompletionDate = "";
        this.daysLeft = 0;
        this.overdue = false;
    }
    
}